import { useEffect } from 'react';
import { useParams, Outlet } from 'react-router';
import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { useErrorBoundary } from 'react-error-boundary';
import { useAuth } from 'hooks';
import { getTeam } from 'queries/teams';

const TeamId = () => {
  const { teamId } = useParams();
  const { showBoundary } = useErrorBoundary();
  const { auth, setAuth } = useAuth();
  const hasTeam = !!auth.teams.find((team) => team.id === teamId);

  const { isSuccess, data: team } = useQuery({
    queryKey: ['team', teamId],
    queryFn: () => getTeam(teamId),
    placeholderData: keepPreviousData,
    staleTime: 60 * 1000,
    gcTime: 60 * 1000,
    enabled: hasTeam
  });

  useEffect(() => {
    if (isSuccess && team) {
      setAuth({
        ...auth,
        last_team: team
      });
    }
  }, [isSuccess, team]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!hasTeam) {
    showBoundary({ status: 404 });
  }

  return team && (
    <Outlet context={{
      team,
      teamId
    }}
    />
  );
};

export default TeamId;
